export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    category: "set",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "",
            title: "property",
            "hard-lock": true,
            editable: true,
          },
        },
        {
          name: "number",
        },
      ],
    },
  },
);
